import { render, staticRenderFns } from "./RSVPTableItem.vue?vue&type=template&id=0584128c&"
import script from "./RSVPTableItem.vue?vue&type=script&lang=js&"
export * from "./RSVPTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports